import { AutogenLayoutFreightCalculator } from "./autogen/AutogenLayoutFreightCalculator";
import { ClickEvent,  PortalLocation, Button,  } from "@mcleod/components";
import { Api,  StringUtil } from "@mcleod/core";
import { ModelOriginCity } from "@mcleod/common/src/models/ModelOriginCity";
import { ModelDestCity } from "@mcleod/common/src/models/ModelDestCity";
// import { ModelCalculateOrderCharges } from "mcleod-ui/mcleod-ui-lme/dispatch/src/models/ModelCalculateOrderCharges";



export class FreightCalculator extends AutogenLayoutFreightCalculator {

    private originLocation: any;
    private destinationLocation: any;
    private originCity: any;
    private destinationCity: any;
    public location: PortalLocation;
    public location2: PortalLocation;



    override onLoad() {
        this.location.lmeLocations=true;
        this.location2.lmeLocations=true;
        this.location.textCombined.quickInfoLayout = null;
        this.location2.textCombined.quickInfoLayout = null;
    }


    rateButtonOnClick(event: ClickEvent) {
        this.rateButtonClicked(event, true);
    }

    rateButtonClicked(event: ClickEvent, autoRate: boolean, estimateFsc: boolean = true) {
        const button = event.target as Button;
        button.busy = true;
        button.enabled = false;

        this.calculateRates(button);



    }

    getLocation(location: any)
    {
        this.sourceLocation.search({ id: location.textCombined.text })
                    .then((response: any) => (location = response?.modelRows[0]));
    }

    getCity(city: any)
    {
        const cityThenStateZip = city.textCombined.text.toString().split(",", 2)
        const stateZip = cityThenStateZip[1].split(" ", 3)
        const cityName = cityThenStateZip[0]
        const state = stateZip[1]
        const zip = stateZip[2]
        if (city.caption === 'Origin City/St/Zip')
            new ModelOriginCity().searchSingle({ name: cityName, state_id: state, zip_code: zip })
                .then((response: any) => this.originCity = response);
        else
            new ModelDestCity().searchSingle({ name: cityName, state_id: state, zip_code: zip })
                .then((response: any) => this.destinationCity = response);
    }

    async calculateRates(button) {

        let ordertype: string = "";
        if (this.orderType.lookupModelData != null)
            ordertype = this.orderType.lookupModelData[0].get("id") ?? "";

        try {
            const endpoint = "portal/customer/freight-calculator"


            await Api.post(endpoint, {
                origin_loc: this.location.lookupModelDataForUpdate.get("id"),
                dest_loc: this.location2.lookupModelDataForUpdate.get("id"),
                origin_cityst: this.location.lookupModelDataForUpdate.get("city_id"),
                dest_cityst: this.location2.lookupModelDataForUpdate.get("city_id"),
                pickupdate: this.pickupDate.getDataValue(),
                weight: this.weight.getDataValue(),
                order_type: ordertype
            }).then(response => {
                const data = response?.data?.[0];
                if (data == null) {
                    this.errorBox.text = "Unable to rate this order. Verify all fields are entered.";
                    return;
                }

                this.estimatedLinehaul.text = data.linehaul;
                this.fuelsurcharge.text = data.fuel_charge;
                this.totalcharge.text = data.totalcharge;
                this.linehaulRate.text = data.linehaulrate;

                console.log("fuel data.fuel_surcharge_rate: " + data.fuel_charge_rate)
                this.fuelRate.text = data.fuel_charge_rate;

                this.errorBox.text = data.response;
                this.rateMethod.text = this.getRatingType(data.rate_type);
                this.weightCharged.text = data.rate_weight;

                if(data.response == "Unable to rate this order, Would you like to send a Rate Request?")
                    this.buttonSendRateRequest.visible=true;


            });
        }
        finally {

            button.busy = false;
            button.enabled = true;

            this.mainDataSource.setComponentsBusy(false);
        }
    }

    async sendRateRequest(button)
    {

        try {
            const endpoint = "portal/customer/send_rate_request"
            await Api.post(endpoint, {
                origin_loc: this.location.lookupModelDataForUpdate.get("id"),
                dest_loc: this.location2.lookupModelDataForUpdate.get("id"),
                origin_cityst: this.location.lookupModelDataForUpdate.get("city_id"),
                dest_cityst: this.location2.lookupModelDataForUpdate.get("city_id"),
                pickupdate: this.pickupDate.getDataValue(),
                weight: this.weight.getDataValue(),
                order_type: this.orderType.lookupModelData[0].get("id")
            }).then(response => {
                const data = response?.data[0];
                this.errorBox.text = data.response;

            });
        }
        finally {

            button.busy = false;
            button.enabled = true;

            this.mainDataSource.setComponentsBusy(false);
        }
    }



/** This is an event handler for the onChange event of OriginCityState. */
  fireCityStateSearch(event) {
    if (event.target.textCombined.text.length >= 10)
        this.getCity(event.target)
  }


  getRatingType(type: string): string {
    if(type=='C')
        return 'CWT';
    else if(type=='D')
        return 'Distance';
    else if(type=='F')
        return 'Flat';
    else if(type=='Tons')
        return 'Tons';
    else
        return 'Unknown';

  }



/** This is an event handler for the onClick event of buttonSendRateRequest. */
  buttonSendRateRequestOnClick(event: ClickEvent) {
    this.sendRequestButtonClicked(event, true);

  }

  sendRequestButtonClicked(event: ClickEvent, autoRate: boolean, estimateFsc: boolean = true) {
    const button = event.target as Button;
    button.busy = true;
    button.enabled = false;

    this.sendRateRequest(button);



}


 }
